"use client";

import deskTopImage from "@root/src/assets/images/collection/banner_collection_desktop_top.webp";
import tabLetImage from "@root/src/assets/images/collection/banner_collection_tablet_top.webp";
import mobileImage from "@root/src/assets/images/collection/banner_collection_mobile_top.webp";
import ResponsiveBanner from "@components/themes/lytra/common/ResponsiveBanner";

interface HeroBannerProps {
  collection: {
    name: string;
    description?: string;
    image?: string[] | string;
  };
}

export default function HeroBanner({ collection }: HeroBannerProps) {
  return (
    <ResponsiveBanner
      alt={collection.name}
      desktopSrc={deskTopImage}
      tabletSrc={tabLetImage}
      mobileSrc={mobileImage}
      priority
      sizes="100vw"
      backgroundColor="#f5eee0"
    />
  );
}
